import { GENRES, REGIONS, YEARS } from '@/lib/film';

interface FilterPanelProps {
  genre?: string;
  region?: string;
  year?: number;
  onGenreChange: (value?: string) => void;
  onRegionChange: (value?: string) => void;
  onYearChange: (value?: number) => void;
}

interface GroupProps {
  title: string;
  allLabel: string;
  options: { label: string; value: string }[];
  activeValue?: string;
  onChange: (value?: string) => void;
}

function FilterGroup({ title, allLabel, options, activeValue, onChange }: GroupProps) {
  return (
    <div>
      <h3 className="mb-2.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-foreground-400">
        <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
        {title}
      </h3>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={() => onChange(undefined)}
          className={`cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
            !activeValue
              ? 'bg-primary-600 font-medium text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          {allLabel}
        </button>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value === activeValue ? undefined : option.value)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
              option.value === activeValue
                ? 'bg-primary-600 font-medium text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  genre,
  region,
  year,
  onGenreChange,
  onRegionChange,
  onYearChange,
}: FilterPanelProps) {
  return (
    <div className="space-y-5">
      <FilterGroup
        title="类型"
        allLabel="全部类型"
        options={GENRES.map((item) => ({ label: item, value: item }))}
        activeValue={genre}
        onChange={onGenreChange}
      />
      <div className="h-px bg-background-200" />
      <FilterGroup
        title="地区"
        allLabel="全部地区"
        options={REGIONS.map((item) => ({ label: item, value: item }))}
        activeValue={region}
        onChange={onRegionChange}
      />
      <div className="h-px bg-background-200" />
      <FilterGroup
        title="年份"
        allLabel="全部年份"
        options={YEARS.map((item) => ({ label: `${item}`, value: `${item}` }))}
        activeValue={year ? `${year}` : undefined}
        onChange={(value) => onYearChange(value ? Number(value) : undefined)}
      />
    </div>
  );
}